import { CSSObject } from 'foundations-theming/utils';
import {
  BreakPointValue,
  BreakPoints,
  BREAKPOINTS,
  SCREEN_SIZES,
  MAX_COLUMNS,
} from './Grid.types';

const generateSizeStyles = (size: BreakPointValue, isOffset = false) => {
  if (size === 0 && !isOffset) {
    return {
      display: 'none',
    };
  }

  const percentage = (size / MAX_COLUMNS) * 100;

  if (isOffset) {
    return {
      marginLeft: `${percentage}%`,
    };
  }

  return {
    flexBasis: `${percentage}%`,
    maxWidth: `${percentage}%`,
  };
};

export const generateResponsiveStyles = (
  breakpoints: BreakPoints,
  isOffset = false
) => {
  if (typeof breakpoints === 'number') {
    return generateSizeStyles(breakpoints, isOffset);
  }

  return SCREEN_SIZES.reduce((acc, screen) => {
    const breakpointValue = breakpoints[screen];

    if (breakpointValue !== undefined) {
      const mediaQuery = `@media (min-width: ${BREAKPOINTS[screen]}px)`;

      acc[mediaQuery] = generateSizeStyles(breakpointValue, isOffset);
    }

    return acc;
  }, {} as CSSObject);
};
